const COLLAPSE_HYSTERESIS_PX = 16;

export function getNextShouldCollapseList({
  shouldCollapseList,
  requiredWidth,
  containerWidth,
}: {
  shouldCollapseList: boolean;
  requiredWidth: number;
  containerWidth: number;
}) {
  if (shouldCollapseList) {
    return requiredWidth > containerWidth - COLLAPSE_HYSTERESIS_PX;
  }

  return requiredWidth > containerWidth;
}
